export enum TriggerEvent {
	ON_CHANGE = 'onchange', // Computed upon related field change
	ON_CREATE = 'oncreate', // Computed once when related domain object is instanced
	ON_FINISH = 'onfinish', // Computed once upon wizard finish
}
